
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { useToast } from '@/hooks/use-toast';
import { supabase } from '@/integrations/supabase/client';

interface ResendVerificationButtonProps {
  email: string;
  className?: string;
}

export const ResendVerificationButton: React.FC<ResendVerificationButtonProps> = ({ 
  email, 
  className = "" 
}) => {
  const [isResending, setIsResending] = useState(false);
  const { toast } = useToast();

  const handleResendVerification = async () => {
    if (!email) return;
    
    setIsResending(true);
    try {
      const { error } = await supabase.auth.resend({
        type: 'signup',
        email: email,
        options: {
          emailRedirectTo: `${window.location.origin}/login?verified=true`
        }
      });

      if (error) throw error;

      toast({
        title: "Verification email sent",
        description: "Please check your email for the new verification link. You'll be automatically logged in after verification.",
      });
    } catch (err: any) {
      console.error("Resend verification error:", err);
      toast({
        title: "Failed to resend email",
        description: err?.message || "Please try again later.",
        variant: "destructive",
      });
    } finally {
      setIsResending(false);
    }
  };

  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      onClick={handleResendVerification}
      disabled={isResending}
      className={className}
    >
      {isResending ? "Sending..." : "Resend verification email"}
    </Button>
  );
};
